<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4 21C4 21.5523 3.55228 22 3 22C2.44772 22 2 21.5523 2 21V3C2 2.44772 2.44772 2 3 2C3.55228 2 4 2.44772 4 3V21ZM6 12L6.004 11.918L6.02024 11.7993L6.04974 11.6879L6.09367 11.5768L6.146 11.4793L6.19631 11.4048L6.29289 11.2929L10.2929 7.29289C10.6834 6.90237 11.3166 6.90237 11.7071 7.29289C12.0676 7.65338 12.0953 8.22061 11.7903 8.6129L11.7071 8.70711L9.415 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H9.415L11.7071 15.2929C12.0676 15.6534 12.0953 16.2206 11.7903 16.6129L11.7071 16.7071C11.3466 17.0676 10.7794 17.0953 10.3871 16.7903L10.2929 16.7071L6.29289 12.7071L6.2515 12.6631L6.19633 12.5953L6.12467 12.4841L6.09365 12.4231L6.05989 12.3417L6.03585 12.266L6.00683 12.1175L6 12Z"
    fill="currentColor"
  />
</svg>
